<div class="searchbar-top gap-2 pb-0">
  <div class="input-group  m-0 matselectfield">
    <span class="input-group-text border-0" id="search-addon">
      <i class="fas fa-search"></i>
    </span>
    <mat-select (selectionChange)="onChangeCollege($event)" class="form-control" [(ngModel)]="collegeId" id="style"
      placeholder="Select College" #singleSelect [title]="selectedCollegeValue ? selectedCollegeValue : ''">
      <mat-option>
        <ngx-mat-select-search placeholderLabel="Select College..." noEntriesFoundLabel="No Matching Data Found"
          [formControl]="FilterCtrl"></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let colleges of filteredData | async" [value]="colleges.id">
        {{colleges.value}}
      </mat-option>
    </mat-select>
  </div>
  <div class="input-group m-0 widthbatch matselectfield">
    <span class="input-group-text border-0" id="search-addon">
      <i class="fas fa-search"></i>
    </span>
    <mat-select (selectionChange)="onChangeBatch($event)" class="form-control" id="style" placeholder="Select Batch"
      #singleSelectBatch [title]="selectedCollegeBatchValue ? selectedCollegeBatchValue : ''">
      <mat-option>
        <ngx-mat-select-search placeholderLabel="Select Batch..." noEntriesFoundLabel="No Matching Data Found"
          [formControl]="Ctrl"></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let collegeBatch of filteredBatchData | async" [value]="collegeBatch.id">
        {{collegeBatch.value}}
      </mat-option>
    </mat-select>
  </div>
  <div class="input-group  m-0">
    <input type="text" class="form-control" [(ngModel)]="enterSearch" placeholder="Search...." aria-label="Search"
      aria-describedby="search-addon" (keyup)="search($event)" oninput="this.value = this.value.replace(/^\s+/g, '')" />
    <span class="input-group-text border-0" id="search-addon">
      <i class="fas fa-search"></i>
    </span>
    <span type="button" class="input-group-append" (click)="cancelSearch()" *ngIf="searchClose">
      <i class="fas fa-times"></i>
    </span>
  </div>
</div>
<div class="searchbar-top gap-2 pt-3">
  <button type="button" class="btn btn-primary common-button m-0" (click)="AddStudent(0)"><i
      class="fas fa-plus pe-2"></i><span>{{StudentConstant.AddStudent}}</span></button>
  <button type="button" class="btn btn-primary common-button m-0" (click)="Upload()"><img
      src="../../../../assets/img/uploadicon.svg" alt="logo"
      class="img-fluid pe-2"><span>{{StudentConstant.UploadFile}}</span></button>
  <button type="button" class="btn btn-primary common-button m-0"
    (click)="DownloadFile()"><span>{{StudentConstant.DownloadTemplate}}</span><img
      src="../../../../assets/img/downloadicon.svg" alt="logo" class="img-fluid ps-2"></button>
  <div class="dropdown exportdropdown" *ngIf="exportButton">
    <a class="btn btn-primary common-button m-0" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
      aria-expanded="false">
      <img src="../../../../assets/img/downloadicon.svg" alt="logo" class="img-fluid pe-2">
      <span>Export</span>
      <i class="fa-solid fa-angle-down ms-3"></i>
    </a>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
      <li><a class="dropdown-item" (click)="ExportStudentList()"
          title="Export Excel">{{StudentConstant.ExportDetails}}</a></li>
      <li><a class="dropdown-item" (click)="downloadPdf()" title="Export PDF">{{ StudentConstant.ExportPdf }}</a></li>
    </ul>
  </div>
  <button type="button" (click)="ResetCollegeSelection()" class="btn btn-primary common-button m-0 icon-btn"><i
      class="fa-solid fa-rotate-right"></i>
  </button>
</div>
<div class="card-content">
  <div class="row table-touch">
    <div class="col-sm-12">
      <div class="mat-custom-table">
        <div class="table-responsive">
          <table mat-table matSort [dataSource]="dataSource" (matSortChange)="SortChange($event)"
            aria-describedby="list">
            <ng-container matColumnDef="rowNumber">
              <th mat-header-cell *matHeaderCellDef> {{CommonConstant.SR}} </th>
              <td mat-cell *matCellDef="let element"> {{element.rowNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="studentName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{StudentConstant.StudentName }}</th>
              <td class="paraWrap" title="{{element.studentName}}" mat-cell *matCellDef="let element"> {{element.studentName}} </td>
            </ng-container>
            <ng-container matColumnDef="collegeName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{StudentConstant.CollegeName }} </th>
              <td mat-cell *matCellDef="let element" title="{{element.collegeName}}" class="wrapper"> <span
                  class="paraWrap"> {{element.collegeName}}
                </span> </td>
            </ng-container>
            <ng-container matColumnDef="batchName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{StudentConstant.BatchName }} </th>
              <td mat-cell *matCellDef="let element"> {{element.batchName}} </td>
            </ng-container>
            <ng-container matColumnDef="emailId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{StudentConstant.EmailAddress}} </th>
              <td mat-cell class="paraWrap" title="{{element.emailId}}" *matCellDef="let element"> {{element.emailId}} </td>
            </ng-container>
            <ng-container matColumnDef="mobileNo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{StudentConstant.PhoneNo}} </th>
              <td mat-cell *matCellDef="let element"> {{element.mobileNo}} </td>
            </ng-container>
            <ng-container matColumnDef="isActive">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{CommonConstant.STATUS}} </th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.isActive == true" class="status text-success" title="Active/Inactive"
                  (click)="onStatus(element.studentId,element.studentName,element.isActive)">{{CommonConstant.ACTIVE}}</span>
                <span *ngIf="element.isActive == false" class="status text-danger" title="Active/Inactive"
                  (click)="onStatus(element.studentId,element.studentName,element.isActive)">{{CommonConstant.INACTIVE}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef> {{CommonConstant.ACTION}} </th>
              <td mat-cell *matCellDef="let element">
                <div class="action-button-group">
                  <a class="detailicon" title="Student Details" (click)="StudentListDetail(element.studentId)"><svg
                      xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-info-lg"
                      viewBox="0 0 16 16">
                      <path
                        d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z" />
                    </svg>
                  </a>
                  <a class="deleteicon" title="Student Delete"
                  (click)="Deletepopup(element.studentId,element.studentName)"><i class="fa fa-trash"></i></a>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="showData" [ngClass]="dataSource.data.length > 0 ? 'hidden' : 'visible'">
            <h5 class="text-center no-data-available py-4">{{NoRecordFound.NoStudentFound}}</h5>
          </div>
        </div>
        <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" showFirstLastButtons
          [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)"
          aria-label="Select page">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>